import React, { Component } from 'react';
import { oneOf, func, string, bool } from 'prop-types';
import cn from 'classnames';
import { t } from 'i18next';

import TooltipWrapper from '~components/TooltipWrapper';
import { TOOLTIP_PLACES } from '~components/TooltipWrapper/constants';
import { DISPATCH_METHODS } from '~constants/address';
import { PAYMENT_METHODS } from '~constants/paymentMethods';
import { FIELDS } from '~screens/Dashboard/screens/Home/screens/Checkout/constants';
import { ANALYTICS_CLASSES } from '~constants/analytics';
import PaymentButton from '~screens/Dashboard/screens/Home/screens/Checkout/components/PaymentMethodContainer/components/PaymentButton';

import { PREFIX_BUTTON } from './constant';
import styles from './styles.module.scss';

class PaymentMethod extends Component {
  handleSelectPaymentMethod = () => {
    const { name, onlinePayment, onSelectPaymentMethod, setFieldValue, closeModal, changingActive } =
      this.props;
    closeModal?.();
    if (setFieldValue) {
      setFieldValue(FIELDS.cardCode, '');
    }
    onSelectPaymentMethod({ paymentMethod: name, onlinePayment, changingActive });
  };

  render() {
    const {
      name,
      iconClassName,
      selectedPaymentMethod,
      dispatchMethod,
      tooltipMessage,
      disabled,
      originalName,
      compactStyle
    } = this.props;

    const paymentButtonName =
      dispatchMethod === DISPATCH_METHODS.PJ_DELIVERY && name === PAYMENT_METHODS.card
        ? t(`CheckoutPaymentMethodList:delivery_${name}`)
        : t(`CheckoutPaymentMethodList:${name}`);
    const hasTooltipMessage = !!tooltipMessage;

    return (
      <TooltipWrapper
        id={paymentButtonName}
        place={TOOLTIP_PLACES.TOP}
        showTooltip={disabled}
        tooltipMessage={tooltipMessage}
        containerClassName={styles.tooltipContainer}>
        <PaymentButton
          id={`${PREFIX_BUTTON}_${name}`}
          name={paymentButtonName}
          onClick={this.handleSelectPaymentMethod}
          className={cn(styles.cardPaymentContainer, ANALYTICS_CLASSES.checkout.paymentMethod, {
            [styles.cardDisabled]: disabled && hasTooltipMessage,
            [styles.compactStyle]: compactStyle
          })}
          selected={
            selectedPaymentMethod === name ||
            (selectedPaymentMethod && selectedPaymentMethod === originalName)
          }
          ariaLabel={paymentButtonName}
          iconClassName={iconClassName}
          disabled={disabled}
          hasTooltipMessage={hasTooltipMessage}
        />
      </TooltipWrapper>
    );
  }
}

PaymentMethod.propTypes = {
  iconClassName: string.isRequired,
  name: oneOf(Object.keys(PAYMENT_METHODS)).isRequired,
  onlinePayment: bool.isRequired,
  setFieldValue: func.isRequired,
  onSelectPaymentMethod: func.isRequired,
  changingActive: bool,
  closeModal: func,
  compactStyle: bool,
  disabled: bool,
  dispatchMethod: string,
  originalName: string,
  selectedPaymentMethod: oneOf(Object.keys(PAYMENT_METHODS)),
  tooltipMessage: string
};

PaymentMethod.defaultProps = {
  tooltipMessage: ''
};

export default PaymentMethod;
